<template>
    <Avatar :image="src" :icon="icon" :label="label" :size="size" :shape="shape" v-if="badge && badge.length" v-badge.danger="badge">
        <slot></slot>
    </Avatar>
    <Avatar :image="src" :icon="icon" :label="label" :size="size" :shape="shape" v-else>
        <slot></slot>
    </Avatar>
</template>

<script>
import Avatar from 'primevue/avatar';

export default {
    name: 'tw-avatar',
    components: {
        Avatar
    },
    props: {
        icon: {
            type: String,
            default: 'pi pi-user'
        },
        size: String,
        shape: String,
        src: String,
        label: String,
        badge: String
    }
}
</script>
